import { withCommonMessages } from '@ti8m/paas-ui';
import de from './de.json';
import en from './en.json';
import it from './it.json';
import fr from './fr.json';

export default {
  de: withCommonMessages(de, 'de'),
  en: withCommonMessages(en, 'en'),
  fr: withCommonMessages(fr, 'fr'),
  it: withCommonMessages(it, 'it'),
};
